import { FormActions } from "../../components/common/FormActions";
import { TTableColumn } from "../../types/common";
import {
  createDeleteAction,
  formatDate,
  getAgo,
  getResultOptions,
} from "../../utils/helpers";

import { useEffect, useState } from "react";
import useGet from "../common/useGet";
import { Link } from "react-router-dom";
import { API_LOAN_APPLICATIONS_DRAFTS } from "../../utils/apis";
import { VIEW } from "../../utils/constants";

export const useLoanApplicationDrafts = () => {
  const [options, setOptions] = useState({ interests: [] });

  const { loadData: getInterests, data: interestData } = useGet();

  useEffect(() => {
    getInterests({
      api: "configurables/interest-configurations/",
      params: {},
    });
  }, []);

  useEffect(() => {
    setOptions({
      ...options,
      interests: getResultOptions(interestData, "purpose", "purpose"),
    });
  }, [interestData]);

  const tableColumns = (): TTableColumn[] => [
    {
      id: "age",
      header: "Age",
    },
    {
      id: "applicant",
      header: "Applicant",
      filter: { type: "text" },
    },
    {
      id: "created_at",
      header: "Created At",
      filter: {
        type: "date",
      },
    },
    {
      id: "application_number",
      header: "Draft Number",
      filter: {
        type: "text",
      },
    },

    {
      id: "application_type",
      header: "Application Type",
      filter: {
        type: "select",
        options: [
          { id: "New Applicant", name: "New Applicant" },
          { id: "Existing Applicant", name: "Existing Applicant" },
          { id: "Migrated Applicant", name: "Migrated Applicant" },
        ],
      },
    },
    { id: "actions", header: "Actions" },
  ];

  const tableData = (data: any) =>
    data.map((item: any) => ({
      ...item,
      created_at: formatDate(item?.created_at),
      age: getAgo(item?.created_at),
      application_number: (
        <Link
          className="link-with-icon"
          to={`/loan_application/drafts/${item?.id}`}
        >
          {item?.application_number}
        </Link>
      ),
      applicant: `${item?.first_name || ""} ${item?.other_name || ""} ${item?.last_name || ""}`,
      actions: (
        <FormActions
          actions={[
            {
              label: VIEW,
              to: `/loan_application/drafts/${item?.id}`,
            },
            createDeleteAction(
              `${API_LOAN_APPLICATIONS_DRAFTS}${item?.id}/`,
              `Loan Application Draft ${item?.application_number}`,
            ),
          ]}
        />
      ),
    }));

  return { tableColumns, tableData };
};
